// Mock data for Decadent Palete - Exclusive & Luxury Atelier/Concierge Hospitality Services

export const mockData = {
  // High-quality professional food images
  heroImages: [
    {
      id: 1,
      url: "https://images.unsplash.com/photo-1414235077428-338989a2e8c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxmaW5lJTIwZGluaW5nfGVufDB8fHx8MTc1NzgxMzg3OHww&ixlib=rb-4.1.0&q=85",
      alt: "Gourmet meal with white wine",
      title: "Luxury Fine Dining Experience"
    },
    {
      id: 2,
      url: "https://images.unsplash.com/photo-1750943082012-efe6d2fd9e45?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwxfHxnb3VybWV0JTIwcGxhdGluZ3xlbnwwfHx8fDE3NTc4MTM4ODZ8MA&ixlib=rb-4.1.0&q=85",
      alt: "Chef presenting beautifully plated dish",
      title: "Artisanal Plating Excellence"
    },
    {
      id: 3,
      url: "https://images.unsplash.com/photo-1750943082020-4969b2a63084?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHwyfHxnb3VybWV0JTIwcGxhdGluZ3xlbnwwfHx8fDE3NTc4MTM4ODZ8MA&ixlib=rb-4.1.0&q=85",
      alt: "Sauce being drizzled with culinary artistry",
      title: "Culinary Artistry"
    }
  ],

  // People enjoying events
  eventImages: [
    {
      id: 1,
      url: "https://images.unsplash.com/photo-1519671282429-b44660ead0a7",
      alt: "People enjoying private dinner party",
      title: "Intimate Private Dining"
    },
    {
      id: 2,
      url: "https://images.unsplash.com/photo-1699730148440-22fc68a96752",
      alt: "Group celebrating with food and drinks",
      title: "Celebration & Joy"
    },
    {
      id: 3,
      url: "https://images.unsplash.com/photo-1699730148132-1409a3728479",
      alt: "Intimate gathering with drinks and food",
      title: "Elegant Gatherings"
    }
  ],

  // Additional food showcase
  foodShowcase: [
    {
      id: 1,
      url: "https://images.unsplash.com/photo-1611520175743-30ff00129621?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHw0fHxmaW5lJTIwZGluaW5nfGVufDB8fHx8MTc1NzgxMzg3OHww&ixlib=rb-4.1.0&q=85",
      alt: "Wellington being sliced with precision",
      title: "Signature Wellington"
    },
    {
      id: 2,
      url: "https://images.pexels.com/photos/2122294/pexels-photo-2122294.jpeg",
      alt: "Elegant plated fine dining dish",
      title: "Elegant Presentation"
    },
    {
      id: 3,
      url: "https://images.pexels.com/photos/33873564/pexels-photo-33873564.jpeg",
      alt: "Professional plated gourmet dish",
      title: "Gourmet Excellence"
    }
  ],

  // Cake Flavors Menu
  cakeFlavors: [
    {
      category: "Classic Favorites",
      flavors: [
        { name: "Vanilla", description: "Timeless vanilla sponge with delicate vanilla bean essence" },
        { name: "Chocolate", description: "Rich, decadent chocolate cake with deep cocoa flavors" },
        { name: "Red Velvet", description: "Velvety smooth cake with subtle cocoa and cream cheese frosting" },
        { name: "Carrot Cake (with Coconut)", description: "Moist spiced carrot cake enhanced with tropical coconut flakes" }
      ]
    },
    {
      category: "Artisan Sponges",
      flavors: [
        { name: "Almond Sponge", description: "Light, airy sponge infused with premium almond extract" },
        { name: "Banana Sponge", description: "Tender banana-infused sponge with natural sweetness" },
        { name: "Coconut Sponge", description: "Tropical coconut sponge with delicate island flavors" }
      ]
    },
    {
      category: "Gourmet Selections",
      flavors: [
        { name: "Pistachio", description: "Luxurious pistachio cake with subtle nutty richness" },
        { name: "Lemon Basil", description: "Bright citrus cake elevated with fresh basil aromatics" },
        { name: "Earl Grey", description: "Sophisticated tea-infused cake with bergamot notes" },
        { name: "Victorian Orange", description: "Classic orange cake with traditional British elegance" }
      ]
    },
    {
      category: "Caribbean & International Fusion",
      flavors: [
        { name: "Caribbean Spiced", description: "Warm spice blend featuring cinnamon, nutmeg, and island aromatics" },
        { name: "Indian Rose & Cardamom", description: "Exotic floral rose cake with fragrant cardamom spice" }
      ]
    }
  ],

  // Cake Fillings Menu
  cakeFillings: [
    {
      category: "Fruit & Berry Delights",
      fillings: [
        { name: "Fresh Strawberry", description: "Pure fresh strawberry filling with natural sweetness" },
        { name: "Strawberry Mousse", description: "Light, airy strawberry mousse with delicate texture" },
        { name: "Cherry", description: "Rich cherry filling with burst of tart-sweet flavor" },
        { name: "Fresh Mango with Cardamom", description: "Tropical mango enhanced with aromatic cardamom spice" },
        { name: "Pineapple Compote", description: "Caramelized pineapple compote with tropical essence" },
        { name: "Raspberry Jam", description: "Premium raspberry jam with perfect balance of sweet and tart" },
        { name: "Guava Jam", description: "Exotic guava jam bringing tropical Caribbean flavors" }
      ]
    },
    {
      category: "Citrus Collection",
      fillings: [
        { name: "Lemon Curd", description: "Silky smooth lemon curd with bright citrus tang" },
        { name: "Orange Curd", description: "Creamy orange curd with vibrant citrus richness" },
        { name: "Passionfruit Curd", description: "Exotic passionfruit curd with tropical tartness" }
      ]
    },
    {
      category: "Rich & Decadent", 
      fillings: [
        { name: "Whipped Chocolate Ganache", description: "Luxurious chocolate ganache whipped to perfection" },
        { name: "Chocolate Pudding", description: "Rich, creamy chocolate pudding with deep cocoa flavors" },
        { name: "Dulce De Leche", description: "Traditional caramelized milk with Latin American authenticity" },
        { name: "Caramel", description: "Classic buttery caramel with golden sweetness" }
      ]
    }
  ],

  // Payment Methods
  paymentMethods: {
    primary: [
      {
        id: 'card',
        name: 'Credit/Debit Card',
        description: 'Visa, Mastercard, American Express, Discover',
        icon: 'CreditCard',
        popular: true,
        processingTime: 'Instant',
        fees: 'Standard processing fees apply'
      },
      {
        id: 'paypal',
        name: 'PayPal',
        description: 'Pay with your PayPal account or linked cards',
        icon: 'Wallet',
        popular: true,
        processingTime: 'Instant',
        fees: 'No additional fees'
      },
      {
        id: 'apple_google_pay',
        name: 'Apple Pay / Google Pay',
        description: 'Quick and secure mobile payments',
        icon: 'Smartphone',
        popular: false,
        processingTime: 'Instant',
        fees: 'No additional fees'
      },
      {
        id: 'ach',
        name: 'Bank Transfer (ACH)',
        description: 'Direct bank account transfer',
        icon: 'Building2',
        popular: false,
        processingTime: '1-3 business days',
        fees: 'No processing fees'
      }
    ],
    alternative: [
      {
        id: 'crypto',
        name: 'Cryptocurrency',
        description: 'Bitcoin, Ethereum, and other digital currencies',
        icon: 'Coins',
        popular: false,
        processingTime: '10-60 minutes',
        fees: 'Network fees apply',
        supportedCurrencies: ['BTC', 'ETH', 'USDT', 'USDC', 'LTC', 'BCH']
      }
    ]
  },

  // Cryptocurrency payment options
  cryptoPaymentOptions: {
    supportedCurrencies: [
      { 
        symbol: 'BTC', 
        name: 'Bitcoin', 
        icon: '₿',
        description: 'The original and most trusted cryptocurrency'
      },
      { 
        symbol: 'ETH', 
        name: 'Ethereum', 
        icon: 'Ξ',
        description: 'Fast and secure smart contract platform'
      },
      { 
        symbol: 'USDT', 
        name: 'Tether USD', 
        icon: '₮',
        description: 'Stable coin pegged to USD for consistent value'
      },
      { 
        symbol: 'USDC', 
        name: 'USD Coin', 
        icon: 'USDC',
        description: 'Regulated stablecoin backed by US dollars'
      },
      { 
        symbol: 'LTC', 
        name: 'Litecoin', 
        icon: 'Ł',
        description: 'Faster transactions with lower fees'
      },
      { 
        symbol: 'BCH', 
        name: 'Bitcoin Cash', 
        icon: 'BCH',
        description: 'Bitcoin fork optimized for payments'
      }
    ],
    paymentProcessor: 'CoinPayments',
    features: [
      'Secure blockchain transactions',
      '24/7 payment processing',
      'Low transaction fees',
      'No chargebacks',
      'Global accessibility',
      'Real-time payment notifications'
    ]
  },

  // Site Navigation Map
  siteMap: {
    mainPages: [
      {
        title: "Home",
        path: "/",
        description: "Decadent Palete - High-end luxury hospitality experiences from large to small events, weddings, travel groups, retreats, and elite celebrations reaching unparalleled sophistication. We provide unforgettable moments and services."
      },
      {
        title: "Services",
        path: "/services",
        description: "Luxury hospitality experiences from large to small events, weddings, travel groups, retreats, and elite celebrations with unparalleled sophistication"
      },
      {
        title: "Custom Cakes",
        path: "/custom-cakes",
        description: "Bespoke cake designs and flavors for special occasions"
      },
      {
        title: "Inquiry",
        path: "/inquiry",
        description: "Event planning and custom cake inquiry forms"
      },
      {
        title: "About Chef",
        path: "/about",
        description: "Meet our executive chef and culinary team"
      }
    ],
    keyFeatures: [
      {
        title: "DP Gift Cards",
        anchor: "#gift-cards",
        description: "Perfect gifts for food lovers and special occasions"
      },
      {
        title: "Partnership Program",
        anchor: "#partnerships", 
        description: "Join our network of culinary partners and affiliates"
      },
      {
        title: "Subscription Tiers",
        anchor: "#subscriptions",
        description: "Exclusive membership benefits and loyalty rewards"
      },
      {
        title: "Premium Services",
        anchor: "#premium-services",
        description: "Grazing tables, multi-course meals, and specialized offerings"
      }
    ],
    specialSections: [
      {
        title: "Cake Flavors & Fillings",
        description: "Comprehensive menu of gourmet cake options"
      },
      {
        title: "Food Allergy Information",
        description: "Safety guidelines and dietary accommodation"
      },
      {
        title: "Pop-up Events",
        description: "Exclusive dining experiences and event notifications"
      },
      {
        title: "Payment Options",
        description: "Multiple secure payment methods including crypto"
      }
    ]
  },

  // DP Gift Cards
  giftCards: {
    title: "Decadent Palete Gift Cards",
    subtitle: "Give the gift of exceptional culinary experiences",
    description: "Perfect for food lovers, special occasions, and those who appreciate the finest in private chef services. Our gift cards never expire and can be used for any of our premium services.",
    amounts: [
      { value: 100, popular: false },
      { value: 250, popular: true },
      { value: 500, popular: false },
      { value: 750, popular: false },
      { value: 1000, popular: false }
    ],
    customAmountRange: {
      min: 50,
      max: 5000
    },
    features: [
      "Never expires",
      "Digital or physical delivery",
      "Personalized message included",
      "Valid for all services",
      "Transferable to others"
    ],
    benefits: [
      "Perfect for birthdays and anniversaries",
      "Corporate gifts for clients and employees",
      "Wedding and shower gifts",
      "Holiday and special occasion presents",
      "Experience gifts for food enthusiasts"
    ]
  },

  // Partnership and Affiliate Program
  partnershipProgram: {
    title: "Partner with Decadent Palete",
    subtitle: "Join our exclusive network of culinary partners and affiliates",
    description: "We collaborate with like-minded businesses and influencers who share our passion for exceptional culinary experiences. Earn generous commissions while promoting luxury food services to your audience.",
    programs: [
      {
        type: "Business Partnership",
        title: "Venue & Event Partners",
        description: "Wedding venues, event planners, and hospitality businesses",
        benefits: [
          "15% commission on referred bookings",
          "Co-marketing opportunities",
          "Exclusive partner pricing",
          "Priority booking access",
          "Joint promotional materials"
        ],
        requirements: [
          "Established venue or event business",
          "Minimum 2 years experience",
          "Professional liability insurance",
          "Aligned brand values"
        ]
      },
      {
        type: "Affiliate Marketing",
        title: "Content Creator Program", 
        description: "Food bloggers, influencers, and content creators",
        benefits: [
          "10% commission on all referrals",
          "Exclusive affiliate discount codes",
          "Free tasting experiences",
          "Professional content for posts",
          "Monthly performance bonuses"
        ],
        requirements: [
          "5,000+ engaged followers",
          "Food/lifestyle focused content",
          "High-quality content standards",
          "Monthly posting commitment"
        ]
      },
      {
        type: "Corporate Partnership",
        title: "Corporate Wellness Partners",
        description: "HR companies, wellness programs, and corporate service providers",
        benefits: [
          "20% commission on corporate bookings",
          "Exclusive corporate menu access",
          "Bulk pricing discounts",
          "Custom partnership agreements",
          "Dedicated account management"
        ],
        requirements: [
          "Corporate client base",
          "B2B sales experience",
          "Professional references",
          "Volume commitment"
        ]
      }
    ],
    applicationProcess: [
      "Submit partnership application",
      "Review of qualifications and portfolio",
      "Virtual meeting with partnership team",
      "Agreement signing and onboarding",
      "Launch partnership with promotional support"
    ],
    contactInfo: {
      email: "partnerships@decadentpalete.com",
      phone: "(973) 666-3705",
      dedicatedManager: "Sarah Johnson, Partnership Director"
    }
  },

  // Custom Cake Portfolio
  customCakes: [
    {
      id: 1,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury/artifacts/ub6oqhjp_IMG_0245.jpeg",
      alt: "Modern white wedding cake with flowing elegant design and pearl accents",
      title: "Elegant Flow Design",
      category: "Wedding Cakes",
      description: "Modern sculptural cake featuring flowing design elements with delicate pearl details"
    },
    {
      id: 2,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury/artifacts/yvnsp606_IMG_0243.jpeg",
      alt: "Multi-tier white wedding cake with fresh white flowers and natural greenery",
      title: "Garden Romance",
      category: "Wedding Cakes", 
      description: "Classic white wedding cake adorned with fresh white roses and natural greenery"
    },
    {
      id: 3,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury/artifacts/6aevy8ve_IMG_0246.jpeg",
      alt: "Baby shower cake with teddy bear, hot air balloon, and Oh Baby text in neutral tones",
      title: "Oh Baby Celebration",
      category: "Baby Shower Cakes",
      description: "Whimsical baby shower cake with teddy bear, hot air balloon, and balloon garland in neutral tones"
    },
    {
      id: 4,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury/artifacts/quldx193_IMG_0244.jpeg",
      alt: "Marble effect wedding cake with blue and white design, roses, and gold E&J lettering",
      title: "Marble Elegance",
      category: "Wedding Cakes",
      description: "Sophisticated marble effect cake with blue watercolor accents, fresh roses, and personalized gold lettering"
    },
    {
      id: 5,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury-1/artifacts/nwzssgef_IMG_0353.jpeg",
      alt: "Luxurious three-tier wedding cake with gold lace details, red roses, and pearl accents",
      title: "Royal Romance",
      category: "Wedding Cakes",
      description: "Elegant three-tier masterpiece featuring intricate gold lace patterns, deep red roses, and pearl detailing"
    },
    {
      id: 6,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury-1/artifacts/p6pu7u2t_IMG_0357.jpeg",
      alt: "Glamorous birthday cake covered in crystal embellishments and rhinestones",
      title: "Diamond Celebration",
      category: "Birthday Cakes",
      description: "Show-stopping celebration cake adorned with countless crystals and rhinestones for ultimate glamour"
    },
    {
      id: 7,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury-1/artifacts/zgd7k401_IMG_0355.jpeg",
      alt: "Elegant two-tier golden anniversary cake with white roses and gold leaf details",
      title: "Golden Milestone",
      category: "Anniversary Cakes",
      description: "Sophisticated anniversary celebration featuring white roses, delicate gold leaf accents, and elegant styling"
    },
    {
      id: 8,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury-1/artifacts/7djrwtiw_IMG_6912.jpeg",
      alt: "Modern geometric three-tier baby shower cake with mint green hexagonal pattern, gold drips, and elegant natural decorations",
      title: "Geometric Garden",
      category: "Baby Shower Cakes", 
      description: "Contemporary baby shower design featuring geometric hexagonal patterns in mint green with gold drip details and natural botanical accents"
    },
    {
      id: 9,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury-1/artifacts/4gngqv11_Neutral%20Minimalist%20Elegant%20Modern%20Menu%20-%201.png",
      alt: "Elegant menu design showcasing custom cake flavors and premium ingredients",
      title: "Signature Flavors Menu",
      category: "Special Occasions",
      description: "Beautifully designed flavor menu featuring our signature cake varieties and premium ingredient selections"
    },
    {
      id: 10,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury-1/artifacts/a0g51f8a_Neutral%20Minimalist%20Elegant%20Modern%20Menu%20-%202.png",
      alt: "Professional cake fillings menu displaying artisanal options and premium selections",
      title: "Artisan Fillings Collection",
      category: "Special Occasions",
      description: "Comprehensive fillings menu showcasing our handcrafted selections and gourmet flavor combinations"
    }
  ],
  chefSignatureCreations: [
    {
      id: 1,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury/artifacts/6s31fc47_IMG_0060.jpeg",
      alt: "Chef's signature Caribbean fusion dish with vibrant mango salsa",
      title: "Caribbean Fusion Delight",
      description: "Pan-seared protein with tropical mango salsa and fresh herbs"
    },
    {
      id: 2,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury/artifacts/ivpi7eni_IMG_0063.jpeg",
      alt: "Elegant braised short rib with fresh figs and cream sauce",
      title: "French-Inspired Elegance",
      description: "Braised short rib with seasonal fig accompaniment and herb-infused cream"
    },
    {
      id: 3,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury/artifacts/z8100a3q_IMG_0065.jpeg",
      alt: "Saffron risotto with perfectly grilled shrimp and microgreens",
      title: "Indian Spice Inspiration",
      description: "Saffron-infused risotto topped with char-grilled prawns and garden microgreens, featuring aromatic Indian spices"
    },
    {
      id: 4,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury-1/artifacts/4wssybxf_IMG_9846.jpeg",
      alt: "Expertly prepared lamb chops with aromatic herbs and rich glazed finish",
      title: "Tandoori-Spiced Lamb Medallions",
      description: "French-cut lamb with Indian tandoori spice blend, rosemary glaze and seasonal vegetables, showcasing Indo-French fusion"
    },
    {
      id: 5,
      url: "https://customer-assets.emergentagent.com/job_chef-luxury-1/artifacts/lory00qo_IMG_0295.jpeg",
      alt: "Artfully plated gourmet dish with rich sauce and elegant presentation",
      title: "Curry-Infused Fine Dining",
      description: "Sophisticated curry reduction with premium protein, featuring traditional Indian aromatics in contemporary French presentation"
    },
    {
      id: 6,
      url: "https://customer-assets.emergentagent.com/job_decadent-palette-dev/artifacts/lond0xzf_IMG_0300.jpeg",
      alt: "Exquisite gourmet creation with elegant plating and premium ingredients",
      title: "Mango Chutney Glazed Creation",
      description: "Masterfully crafted dish with Indian mango chutney glaze, showcasing Caribbean-Indian fusion with seasonal ingredients"
    },
    {
      id: 7,
      url: "https://customer-assets.emergentagent.com/job_decadent-palette-dev/artifacts/kzqdd5xq_IMG_0294.jpeg",
      alt: "Sophisticated fine dining creation with intricate details and gourmet styling",
      title: "Cardamom & Coconut Innovation",
      description: "Innovative creation featuring Indian cardamom and coconut milk reduction with sophisticated Caribbean-Indian plating"
    },
    {
      id: 8,
      url: "https://customer-assets.emergentagent.com/job_decadent-palette-dev/artifacts/62u80tw2_IMG_0293.jpeg",
      alt: "Premium gourmet dish with elegant presentation and refined flavor profile",
      title: "Turmeric-Seared Perfection",
      description: "Perfectly executed dish with turmeric and garam masala seasoning, highlighting Indian-influenced culinary artistry"
    }
  ],

  // Services data
  services: [
    {
      id: 1,
      title: "Corporate Occasions",
      description: "Elevate your business events with our sophisticated culinary offerings",
      features: ["Executive dining experiences", "Team building culinary events", "Business lunch catering"]
    },
    {
      id: 2,
      title: "Family Meals",
      description: "Intimate family dining experiences crafted with love and expertise",
      features: ["Weekly meal prep", "Special occasion dining", "Family celebration menus"]
    },
    {
      id: 3,
      title: "Private Chef Services",
      description: "Personalized culinary experiences in the comfort of your home",
      features: ["In-home dining experiences", "Personal meal planning", "Dietary accommodation"]
    },
    {
      id: 4,
      title: "Small & Large Events",
      description: "From intimate gatherings to grand celebrations",
      features: ["Birthday celebrations", "Anniversary dinners", "Holiday gatherings"]
    },
    {
      id: 5,
      title: "Wedding Services",
      description: "Make your special day unforgettable with our wedding catering",
      features: ["Buffet service", "A la carte options", "Custom wedding menus"]
    }
  ],

  // Premium Service Offerings
  premiumServices: {
    menuImage: "https://customer-assets.emergentagent.com/job_chef-luxury/artifacts/zqpudhck_Beige%20Minimalist%20Aesthetic%20Photography%20Price%20Guide%20Flyer.png",
    services: [
      {
        name: "Grazing Table",
        description: "Artfully arranged charcuterie and seasonal selections for sophisticated gatherings"
      },
      {
        name: "3-6 Course Experience Meal",
        description: "Multi-course culinary journey featuring our signature fusion cuisine"
      },
      {
        name: "Brunch Tea Party",
        description: "Elegant afternoon service with gourmet tea selections and delicate treats"
      },
      {
        name: "Holiday Family Meal",
        description: "Festive seasonal menus designed for memorable family celebrations"
      },
      {
        name: "Amuse Bouche",
        description: "Sophisticated single-bite appetizers to begin your culinary experience"
      },
      {
        name: "Delivery Lunch Packages",
        description: "Premium lunch boxes delivered fresh for corporate or personal dining"
      },
      {
        name: "Couple's Private Dinner",
        description: "Intimate dining experience crafted for romantic celebrations"
      },
      {
        name: "Passed Hors d'oeuvres",
        description: "Elegant canapés and appetizers served during cocktail receptions"
      }
    ]
  },

  // Dessert services
  dessertServices: [
    {
      id: 1,
      title: "Custom Cake Services",
      description: "Bespoke cakes designed to perfection for your special occasions",
      features: ["Wedding cakes", "Birthday celebrations", "Corporate events"]
    },
    {
      id: 2,
      title: "Decorated Dessert Tables",
      description: "Stunning dessert displays that wow your guests",
      features: ["Event dessert bars", "Themed presentations", "Seasonal specialties"]
    }
  ],

  // Subscription tiers
  subscriptionTiers: [
    {
      id: 1,
      name: "Loyal Tier 1",
      benefits: [
        "5% off the entire menu*",
        "5% off all drinks (alcoholic and non-alcoholic)*",
        "Access to hidden Chef menu (Caribbean/French/Indian influence fusion)",
        "Earn loyalty points for future rewards",
        "🎯 Referral Program: Earn 5% commission for every friend who joins DP exclusive membership"
      ],
      referralRate: 5,
      note: "*Not applicable for large private events and banquets"
    },
    {
      id: 2,
      name: "Loyal Tier 2",
      benefits: [
        "10% off the entire menu*",
        "5% off all drinks (alcoholic and non-alcoholic)*",
        "Access to hidden menu (Caribbean/French/Indian influence fusion)",
        "Loyalty points for future rewards",
        "Early access to exclusive Decadent Palete private events",
        "🎯 Referral Program: Earn 10% commission for every friend who joins DP exclusive membership"
      ],
      referralRate: 10,
      note: "*Not applicable for large private events and banquets"
    },
    {
      id: 3,
      name: "Loyal Tier 3",
      benefits: [
        "10% off the entire menu*",
        "10% off all drinks (alcoholic and non-alcoholic)*",
        "Access to hidden menu (Caribbean/French/Indian influence fusion)",
        "Earn loyalty points for future rewards",
        "Exclusive invitation to Decadent Palete private events",
        "Founding perks for first 100 Royal sign-ups:",
        "• Private free tasting for new items (4-10 people via RSVP)",
        "• Early access to exclusive events (Spring Brunch, Summer Picnic, New Year's Eve Gala)",
        "• VIP seating with bottle service at private events",
        "🎯 Referral Program: Earn 15% commission for every friend who joins DP exclusive membership"
      ],
      referralRate: 15,
      note: "*Not applicable for large private events and banquets",
      isRoyal: true
    }
  ],

  // Executive Chef & Culinary Artisan
  chef: {
    name: "Executive Chef Marcus Thompson",
    bio: "Trained at Le Cordon Bleu and refined through Michelin-starred kitchens across Europe, Executive Chef Marcus Thompson specializes in creating high-end luxury hospitality experiences from large to small events, weddings, travel groups, retreats, and elite celebrations. With over 15 years orchestrating bespoke experiences that reach unparalleled sophistication, Chef Thompson doesn't just cook — he provides unforgettable moments and services.",
    specialties: ["Large to Small Event Experiences", "Luxury Wedding Productions", "Private Travel Group Hospitality", "Exclusive Retreat Curation", "Elite Celebration Services"],
    experience: "15+ years in luxury hospitality",
    philosophy: "We provide high-end luxury hospitality experiences from large to small events, weddings, travel groups, retreats, and elite celebrations reaching unparalleled sophistication. We don't just cook — we provide unforgettable moments and services."
  },

  // Contact information
  contact: {
    phone: "(973) 666-3705",
    email: "info@decadentpalete.com",
    phoneLink: "tel:9736663705",
    emailLink: "mailto:info@decadentpalete.com",
    website: "https://decadentpalete.com"
  },

  // Social media links
  socialMedia: [
    { platform: "Instagram", url: "https://instagram.com/decadentpalete", icon: "Instagram" },
    { platform: "Twitter", url: "https://twitter.com/decadentpalete", icon: "Twitter" },
    { platform: "LinkedIn", url: "https://linkedin.com/company/decadentpalete", icon: "Linkedin" }
  ],

  // Pop-up events mock
  popupEvents: [
    {
      id: 1,
      title: "Caribbean Fusion Night",
      date: "2025-02-15",
      description: "Experience authentic Caribbean flavors with a modern twist"
    },
    {
      id: 2,
      title: "French Culinary Experience",
      date: "2025-02-28",
      description: "Classic French techniques meet contemporary presentation"
    },
    {
      id: 3,
      title: "Spring Tasting Menu",
      date: "2025-03-15",
      description: "Seasonal ingredients showcased in our signature style"
    }
  ],

  // Indian-Influenced Signature Menu Items
  indianFusionMenu: {
    appetizers: [
      {
        id: 1,
        name: "Coconut Curry Shrimp Croquettes",
        description: "Caribbean coconut meets Indian curry spices in crispy French-style croquettes with mango chutney drizzle",
        price: "Contact for Quote",
        dietaryInfo: ["Gluten-Free Available"],
        spiceLevel: "Medium"
      },
      {
        id: 2,
        name: "Tandoori Spiced Beef Tartare",
        description: "French beef tartare elevated with tandoori spices, served with naan crisps and mint cilantro chutney",
        price: "Contact for Quote",
        dietaryInfo: ["Premium Cut"],
        spiceLevel: "Mild"
      },
      {
        id: 3,
        name: "Turmeric-Seared Scallops",
        description: "Pan-seared scallops with turmeric and garam masala, coconut risotto, and curry oil painting",
        price: "Contact for Quote",
        dietaryInfo: ["Gluten-Free", "Premium Seafood"],
        spiceLevel: "Mild"
      }
    ],
    mains: [
      {
        id: 1,
        name: "Cardamom-Braised Lamb Shoulder",
        description: "French braising technique with Indian cardamom, served with coconut rice and Caribbean plantain chutney",
        price: "Contact for Quote",
        dietaryInfo: ["Premium Cut", "Dairy-Free Available"],
        spiceLevel: "Medium"
      },
      {
        id: 2,
        name: "Curry-Glazed Duck Breast",
        description: "Five-spice duck with Indian curry glaze, saffron sweet potato purée, and pickled mango garnish",
        price: "Contact for Quote",
        dietaryInfo: ["Premium Poultry", "Gluten-Free"],
        spiceLevel: "Medium-Hot"
      },
      {
        id: 3,
        name: "Masala-Spiced Halibut",
        description: "Pan-roasted halibut with garam masala crust, coconut curry beurre blanc, and crispy curry leaves",
        price: "Contact for Quote",
        dietaryInfo: ["Premium Seafood", "Gluten-Free"],
        spiceLevel: "Mild"
      },
      {
        id: 4,
        name: "Tandoori Vegetable Wellington",
        description: "Tandoori-spiced vegetables in puff pastry with cashew cream sauce and mint oil",
        price: "Contact for Quote",
        dietaryInfo: ["Vegetarian", "Vegan Available"],
        spiceLevel: "Medium"
      }
    ],
    desserts: [
      {
        id: 1,
        name: "Cardamom Crème Brûlée",
        description: "Classic French custard infused with Indian cardamom, topped with jaggery tuile and rose petals",
        price: "Contact for Quote",
        dietaryInfo: ["Vegetarian"],
        spiceLevel: "None"
      },
      {
        id: 2,
        name: "Mango Kulfi Tart",
        description: "Indian kulfi ice cream in French tart shell with caramelized mango and pistachio dust",
        price: "Contact for Quote",
        dietaryInfo: ["Vegetarian", "Contains Nuts"],
        spiceLevel: "None"
      },
      {
        id: 3,
        name: "Chai-Spiced Chocolate Soufflé",
        description: "Light chocolate soufflé with chai tea spices, served warm with saffron ice cream",
        price: "Contact for Quote",
        dietaryInfo: ["Vegetarian"],
        spiceLevel: "None"
      }
    ]
  }
};

// Mock form submission handlers
export const mockFormHandlers = {
  subscribeToNewsletter: (email) => {
    console.log('Newsletter subscription:', email);
    return Promise.resolve({ success: true, message: 'Successfully subscribed to newsletter!' });
  },

  joinPopupEvents: (email) => {
    console.log('Pop-up events signup:', email);
    return Promise.resolve({ success: true, message: 'Successfully signed up for pop-up event notifications!' });
  },

  submitInquiry: (formData) => {
    console.log('Inquiry submitted:', formData);
    return Promise.resolve({ success: true, message: 'Inquiry submitted successfully! We will contact you within 24 hours.' });
  },

  subscribeToTier: (tierData) => {
    console.log('Tier subscription:', tierData);
    return Promise.resolve({ success: true, message: `Successfully subscribed to ${tierData.tierName}!` });
  }
};